import { render, staticRenderFns } from "./JdProductDialog.vue?vue&type=template&id=5eab4a9c&scoped=true&"
import script from "./JdProductDialog.vue?vue&type=script&lang=js&"
export * from "./JdProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./JdProductDialog.vue?vue&type=style&index=0&id=5eab4a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eab4a9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VDataTable,VRow})
